import {
  Box,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid2,
  InputLabel,
  Radio,
  RadioGroup,
  SnackbarContent,
  Tab,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MUIButton from "../../reusable_components/components/MUIButton";
import MUICancelButton from "../../reusable_components/components/MuiCancelButton";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import {
  useForgetPassword1Mutation,
  useRecruiterApproveOrSuspendedMutation,
  useSecondLevelAprroveOrSuspendMutation,
} from "../../redux/Recruiters/RecruiterDetails.api";
import { useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import { SnackbarContext } from "../../reusable_components/components/Snackbar";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import "./RecruiterDetails.css";
import { Controller, useForm } from "react-hook-form";
import * as Yup from "yup";
import Dropdown from "../../reusable_components/components/Dropdown";
import { yupResolver } from "@hookform/resolvers/yup";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { useViewRecruiterDetailsByIdForAdminQuery } from "../../redux/Profile/profile.api";
import DescriptionIcon from "@mui/icons-material/Description";
import dayjs from "dayjs";
import Loader from "../../reusable_components/components/Loader";
import {
  useGetPositionLevelDropDownQuery,
  useGetWorkCategoryDropDownQuery,
  useUpdateJobPositionLevelMutation,
  useUpdateWorkCategoryMutation,
} from "../../redux/Signup/signup.api";

const FileLink = ({ filePath, displayName }) => {
  // Remove the unwanted part of the file path
  const cleanFilePath = filePath?.replace(
    /^.*\/html/,
    window.REACT_APP_FILEDOWNLOAD_URL
  );
  // const cleanFilePath = filePath?.replace(/^.*\/html/, 'https://stage-or.g-axis.in');

  const fileNameWithExtension = filePath?.split("/").pop();

  const getIconByExtension = (filePath) => {
    const extension = filePath?.split(".").pop().toLowerCase();
    switch (extension) {
      case "docx":
      case "doc":
        return (
          <DescriptionIcon style={{ marginRight: "8px", color: "#1E88E5" }} />
        );
      case "pdf":
        return (
          <DescriptionIcon style={{ marginRight: "8px", color: "#FF5252" }} />
        );
      default:
        return (
          <DescriptionIcon style={{ marginRight: "8px", color: "#555" }} />
        );
    }
  };

  const handleClick = (e) => {
    e.preventDefault(); // Prevent default anchor behavior
    window.open(cleanFilePath, "_blank");
  };

  return (
    <>
      <Typography
        variant="body2"
        style={{ marginBottom: "5px", fontWeight: 500 }}
      >
        {displayName} {/* Display name above the file link */}
      </Typography>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "10px",
          border: "1px solid grey",
          borderRadius: "8px",
          padding: "7px 14px",
          maxWidth: "100%", // Prevents overflow
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          background: "#F9F9F9", // Light background for a card-like look
        }}
      >
        {getIconByExtension(filePath)}
        <a
          href="#"
          onClick={handleClick}
          style={{
            textDecoration: "none",
            color: "#007BFF",
            marginLeft: "10px",
            flex: 1, // Ensures text takes remaining space
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            cursor: "pointer",
            fontWeight: 500,
          }}
          title={fileNameWithExtension} // Show full name on hover
        >
          {fileNameWithExtension}
        </a>
      </div>
    </>
  );
};

const RecruiterDetails = () => {
  const { Snackbar } = useContext(SnackbarContext);
  const { recruiterIdAdmin, recruiterStatus, externalRecruiter } = useSelector(
    (state) => state?.common
  );

  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [open, setOpen] = useState(false);
  const [isCost, setIsCost] = useState(false);
  const [showOverAllLoader, setShowOverAllLoader] = useState(false);

  const { data: getWorkCategoryDropDown } = useGetWorkCategoryDropDownQuery();
  const { data: getPositionLevelDropDown } = useGetPositionLevelDropDownQuery();
  const [updateWorkCategory] = useUpdateWorkCategoryMutation();
  const [updateJobPositionLevel] = useUpdateJobPositionLevelMutation();
  const [selectedKeywordIds, setSelectedKeywordIds] = useState([]);
  const [selectedLevelIds, setSelectedLevelIds] = useState([]);
  const [editCheck, setEditCheck] = useState(false);
  const [editLevelCheck, setEditLevelCheck] = useState(false);
  const [checkLoading, setCheckLoading] = useState(false);

  const updateCategory = async (clickedId) => {
    setCheckLoading(true);
    try {
      const payload = {
        recruiterUserId:
          ViewRecruiterDetailsById?.response?.data?.[0]?.recruiterUserId,
        workCategoryIds: [clickedId], // send only clicked id
      };

      const response = await updateWorkCategory(payload).unwrap();

      if (response?.response?.status === "success") {
        Snackbar(response?.response?.message, "success");
        setEditCheck(false);
      } else {
        Snackbar(response?.response?.removed?.message, "error");
      }
    } catch (error) {
      Snackbar("Network error", "error");
    } finally {
      setCheckLoading(false);
    }
  };

  const handleCheckboxChange = (id) => {
    let updatedIds = [];

    if (selectedKeywordIds.includes(id)) {
      updatedIds = selectedKeywordIds.filter((item) => item !== id);
    } else {
      updatedIds = [...selectedKeywordIds, id];
    }

    setSelectedKeywordIds(updatedIds);
    updateCategory(id);
  };

  const updateLevel = async (clickedId) => {
    setCheckLoading(true);
    try {
      const payload = {
        recruiterUserId:
          ViewRecruiterDetailsById?.response?.data?.[0]?.recruiterUserId,
        jobPositionLevelIds: [clickedId], // only clicked id
      };

      const response = await updateJobPositionLevel(payload).unwrap();

      if (response?.response?.status === "success") {
        Snackbar(response?.response?.message, "success");
        setEditLevelCheck(false);
      } else {
        Snackbar(response?.response?.removed?.message, "error");
      }
    } catch (error) {
      Snackbar("Network error", "error");
    } finally {
      setCheckLoading(false);
    }
  };

  const handleLevelChange = (id) => {
    let updatedIds = [];

    if (selectedLevelIds.includes(id)) {
      updatedIds = selectedLevelIds.filter((item) => item !== id);
    } else {
      updatedIds = [...selectedLevelIds, id];
    }

    setSelectedLevelIds(updatedIds);
    updateLevel(id);
  };

  const validationSchema = Yup.object().shape({
    rewardType: Yup.string().required("Reward type is required"),
    rewardsRs: isCost
      ? Yup.string().required("Reward amount is required")
      : Yup.string(),
    rewardsPercent: !isCost
      ? Yup.string().required("Reward percentage is required")
      : Yup.string(),
  });

  const resolver = yupResolver(
    externalRecruiter === "Y" ? validationSchema : Yup.object()
  );

  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
    reset,
  } = useForm({
    resolver,
    defaultValues: {
      rewardType: "",
      rewardsRs: "",
      rewardsPercent: "",
    },
  });

  // APIs
  const [forgetPassword1] = useForgetPassword1Mutation();
  const [recruiterApproveOrSuspended] =
    useRecruiterApproveOrSuspendedMutation();
  const [secondLevelAprroveOrSuspend] =
    useSecondLevelAprroveOrSuspendMutation();

  const [reason, setReason] = useState("");
  const [isReason, setIsReason] = useState("");
  const [tabValue, setTabValue] = useState(
    () => Number(localStorage.getItem("selectedTab")) || 1
  );

  const {
    recruiterName,
    recruiterId,
    addressone,
    state,
    phone,
    email,
    companyName,
    city,
    pincode,
    alternatePhone,
    alternateEmail,
    status,
    reasonDesc,
    rewardType,
    rewardAmount,
    rewardPercentage,
    external,
  } = location.state || " ";

  const { data: ViewRecruiterDetailsById, refetch } =
    useViewRecruiterDetailsByIdForAdminQuery({ recruiterId: recruiterIdAdmin });

  const PositionLevel = ViewRecruiterDetailsById?.response?.data[0].jobPositionLevels.map((name) => (name?.jobPositionLevelsName))
  const workCategories = ViewRecruiterDetailsById?.response?.data[0].workCategories.map((name) => (name?.workCategoryName))

  const { Profile } = useSelector((state) => state.common);
  const id = Profile?.profile?.id;
  const role = Profile?.profile?.role;

  useEffect(() => {
    if (checkLoading) {
      const timer = setTimeout(() => {
        refetch();
      }, 1000);
      return () => clearTimeout(timer);
    } else {
      refetch();
    }
  }, [checkLoading]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setIsReason("");
    setReason("");
  };

  const handleReason = (e) => {
    setReason(e.target.value);

    if (reason === "") {
      setIsReason("Reason for Rejection is Required");
    }
  };

  const handleResetPassword = async () => {
    try {
      const payload = {
        email: email,
      };
      const response = await forgetPassword1(payload).unwrap();
      Snackbar(response?.response?.message, "success");
    } catch (error) {
      Snackbar("Network error", "error");
    }
  };

  const handleSuspend = async () => {
    try {
      if (reason === "" || reason === null) {
        return setIsReason("Reason for Rejection is Required");
      }
      if (role === "admin") {
        const payload = {
          adminId: id,
          reasonDesc: reason,
          recruiterId:
            ViewRecruiterDetailsById?.response?.data?.[0]?.recruiterId,
          status: "Suspended",
        };
        setShowOverAllLoader(true);
        const response = await recruiterApproveOrSuspended(payload).unwrap();
        setShowOverAllLoader(false);
        Snackbar(response?.response?.message, "success");
        handleClose();
        navigate("/recruiter-list");
      } else {
        Snackbar("Coordinator & Recruiter cannot Approve", "error");
        setShowOverAllLoader(false);
      }
    } catch (error) {
      Snackbar("Network error", "error");
      setShowOverAllLoader(false);
    }
  };

  const handleSecondLvlSuspend = async () => {
    try {
      if (reason === "" || reason === null) {
        return setIsReason("Reason for Rejection is Required");
      }
      if (role === "admin") {
        const payload = {
          adminId: id,
          secondLevelReasonDesc: reason,
          recruiterId:
            ViewRecruiterDetailsById?.response?.data?.[0]?.recruiterId,
          status: "Suspended",
        };
        setShowOverAllLoader(true);
        const response = await secondLevelAprroveOrSuspend(payload).unwrap();
        setShowOverAllLoader(false);
        Snackbar(response?.response?.message, "success");
        handleClose();
        navigate("/recruiter-list");
      } else {
        Snackbar("Coordinator & Recruiter cannot Approve", "error");
        setShowOverAllLoader(false);
      }
    } catch (error) {
      Snackbar("Network error", "error");
      setShowOverAllLoader(false);
    }
  };

  const type = watch("rewardType");

  useEffect(() => {
    if (type === 1) {
      setIsCost(true);
    } else {
      setIsCost(false);
    }
  }, [watch, type]);

  const handleApprove = async (data) => {
    if (role === "admin") {
      try {
        const payload = {
          adminId: id,
          reasonDesc: "",
          recruiterId:
            ViewRecruiterDetailsById?.response?.data?.[0]?.recruiterId,
          status: "Approved",
        };
        setShowOverAllLoader(true);
        const response = await recruiterApproveOrSuspended(payload).unwrap();
        setShowOverAllLoader(false);
        Snackbar(response?.response?.message, "success");
        navigate("/recruiter-list");
      } catch (error) {
        Snackbar("Network error", "error");
        setShowOverAllLoader(false);
      }
    } else {
      Snackbar("Coordinator & Recruiter cannot Approve", "error");
      setShowOverAllLoader(false);
    }
  };

  const handleSecondLevelApprove = async (data) => {
    if (role === "admin") {
      try {
        const payload = {
          adminId: id,
          secondLevelReasonDesc: "",
          recruiterId:
            ViewRecruiterDetailsById?.response?.data?.[0]?.recruiterId,
          status: "Approved",
        };
        setShowOverAllLoader(true);
        const response = await secondLevelAprroveOrSuspend(payload).unwrap();
        setShowOverAllLoader(false);
        Snackbar(response?.response?.message, "success");
        navigate("/recruiter-list");
      } catch (error) {
        Snackbar("Network error", "error");
        setShowOverAllLoader(false);
      }
    } else {
      Snackbar("Coordinator & Recruiter cannot Approve", "error");
      setShowOverAllLoader(false);
    }
  };

  const handleTabChange = (e, newValue) => {
    setTabValue(newValue);
    localStorage.setItem("selectedTab", newValue);
  };

  const handleRecruiterEditLv1 = () => {
    navigate("/recruiter-editLvl1", {
      state: { recruiterIdAdmin: recruiterId },
    });
  };

  const handleRecruiterEdit = () => {
    navigate("/recruiter-edit", { state: { recruiterIdAdmin: recruiterId } });
  };

  const files = [
    {
      filePath: ViewRecruiterDetailsById?.response?.data[0]?.resumeFile,
      displayName: "Resume",
    },
    {
      filePath: ViewRecruiterDetailsById?.response?.data[0]?.companyProfileFile,
      displayName: "Company Profile",
    },
    {
      filePath: ViewRecruiterDetailsById?.response?.data[0]?.aadhaarcardFile,
      displayName: "Aadhaar Card",
    },
    {
      filePath: ViewRecruiterDetailsById?.response?.data[0]?.pancardFile,
      displayName: "PAN Card",
    },
    {
      filePath:
        ViewRecruiterDetailsById?.response?.data[0]?.bankCancelledChequeFile,
      displayName: "Bank Cancelled Cheque",
    },
  ];

  const mandatoryDocuments = [
    "PAN Card",
    "Bank Cancelled Cheque",
    "Aadhaar Card",
  ];

  const isFile = files.filter((file) => file.filePath === null);
  const checking = isFile
    .filter((file) => mandatoryDocuments?.includes(file?.displayName))
    .map((file) => file.displayName);
  const isReward = ViewRecruiterDetailsById?.response?.data[0]?.rewardType
    ? true
    : false;

  // const isApproveDisabled = tabValue === 2 &&
  //     ViewRecruiterDetailsById?.response?.data?.[0]?.rewardType === null;

  const isApproved =
    ViewRecruiterDetailsById?.response?.data?.[0]?.isDocsVerify;

  const isApproveDisabled =
    tabValue === 2 &&
    ViewRecruiterDetailsById?.response?.data?.[0]?.isDocsVerify === "N" &&
    (ViewRecruiterDetailsById?.response?.data?.[0]?.rewardType === null ||
      (ViewRecruiterDetailsById?.response?.data?.[0]?.secondLevelReasonDesc !==
        null &&
        ViewRecruiterDetailsById?.response?.data?.[0]?.secondLevelReasonDesc ===
        " "));

  useEffect(() => {
    setSelectedLevelIds(
      ViewRecruiterDetailsById?.response?.data?.[0]?.jobPositionLevels?.map(
        (item) => item.jobPositionLevelsId
      ) || []
    );
    setSelectedKeywordIds(
      ViewRecruiterDetailsById?.response?.data?.[0]?.workCategories?.map(
        (item) => item.workCategoryId
      ) || []
    );
  }, [ViewRecruiterDetailsById]);
  const isDocsVerify = ViewRecruiterDetailsById?.response?.data?.[0]?.isDocsVerify
  const recruiterStatus_v1 = ViewRecruiterDetailsById?.response?.data?.[0]?.recruiterStatus

  return (
    <Box className="container">
      {showOverAllLoader ? <Loader /> : ""}
      <Grid2
        item
        sx={{
          display: "flex",
          alignItems: "center",
          color: "#6941C6",
          gap: "4px",
          cursor: "pointer",
          width: "40px",
          marginBottom: "20px",
        }}
        onClick={() => navigate("/recruiter-list")}
      >
        <ArrowBackIcon sx={{ fontSize: "17px" }} />
        <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>Back</Typography>
      </Grid2>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Typography className="title">Recruiter Details</Typography>
        {/* <MUICancelButton title="Cancel" component={Link} to='/recruiter-list'></MUICancelButton> */}
        <Grid2 sx={{ display: "flex", gap: "20px" }}>
          {tabValue === 1 &&
            (recruiterStatus_v1 === "Pending" ||
              recruiterStatus_v1 === "Approved") && (
              <Grid2 sx={{ display: "flex", gap: "20px" }}>
                <MUIButton
                  title="Suspend"
                  sx={{
                    backgroundColor: "#FFF4ED",
                    border: "1px solid #FFD6AE",
                    color: "#D92D20",
                  }}
                  onClick={handleOpen}
                />
              </Grid2>
            )}

          {tabValue === 2 && checking.length === 0 && (isApproved === "P" || isApproved === "Y") && (
            <Grid2 sx={{ display: "flex", gap: "20px" }}>
              <MUIButton
                title="Suspend"
                sx={{
                  backgroundColor: "#FFF4ED",
                  border: "1px solid #FFD6AE",
                  color: "#D92D20",
                  "&.Mui-disabled": {
                    backgroundColor: "#F3F3F3", // Lighter dull color
                    border: "1px solid #D1D1D1", // Lighter border
                    color: "#A0A0A0", // Dull text color
                    opacity: 0.7, // Reduce opacity slightly
                  },
                }}
                onClick={handleOpen}
                disabled={isApproveDisabled}
              />
            </Grid2>
          )}

          {tabValue === 1 &&
            (recruiterStatus_v1 === "Pending" ||
              recruiterStatus_v1 === "Suspended") && (
              <Grid2 sx={{ display: "flex", gap: "20px" }}>
                <MUIButton
                  title="Approve"
                  sx={{
                    backgroundColor: "#ECFDF3",
                    border: "1px solid #ABEFC6",
                    color: "#067647",
                  }}
                  onClick={handleApprove}
                />
              </Grid2>
            )}

          {tabValue === 2 && isApproved !== "Y" && checking.length === 0 && (
            <Grid2 sx={{ display: "flex", gap: "20px" }}>
              <MUIButton
                title="Approve"
                sx={{
                  backgroundColor: "#ECFDF3",
                  border: "1px solid #ABEFC6",
                  color: "#067647",
                  "&.Mui-disabled": {
                    backgroundColor: "#F3F3F3", // Lighter dull color
                    border: "1px solid #D1D1D1", // Lighter border
                    color: "#A0A0A0", // Dull text color
                    opacity: 0.7, // Reduce opacity slightly
                  },
                }}
                onClick={handleSecondLevelApprove}
                disabled={isApproveDisabled}
              />
            </Grid2>
          )}
          {tabValue === 1 && (
            <MUIButton
              disabled={role === "coordinator"}
              title="Edit"
              className="edit-button"
              onClick={handleRecruiterEditLv1}
            />
          )}
          {tabValue === 2 && (
            <MUIButton
              disabled={role === "coordinator"}
              title="Edit"
              className="edit-button"
              onClick={handleRecruiterEdit}
            />
          )}

          {/* {(tabValue === 1) && (
                        <MUICancelButton title="Reset Password" type='submit' onClick={handleResetPassword}
                            sx={{
                                border: '1px solid #D6BBFB',
                                color: '#6941C6',
                                width: '130px',
                            }}
                        />
                    )} */}
        </Grid2>
      </div>
      <TabContext value={tabValue}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList onChange={handleTabChange}>
            <Tab
              label="Level 1"
              className="tabs"
              value={1}
              sx={{ textTransform: "none", fontWeight: "bold" }}
            />
            {ViewRecruiterDetailsById?.response?.data[0]
              ?.isExternalRecruiter === "Y" && (
                <Tab
                  label="Level 2"
                  className="tabs"
                  value={2}
                  sx={{ textTransform: "none", fontWeight: "bold" }}
                />
              )}
          </TabList>
        </Box>
        <TabPanel value={1} sx={{ padding: 1.5 }}>
          <Typography
            sx={{ fontWeight: "bold", fontSize: "18px", marginBottom: "10px" }}
          >
            Basic Information
          </Typography>
          <Grid2
            container
            item
            sx={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: !isSmallScreen ? "row" : "column",
            }}
          >
            <Grid2
              item
              container
              rowGap={2}
              sx={{
                display: "flex",
                flexDirection: "column",
                width: !isSmallScreen ? "40%" : "100%",
              }}
            >
              {/* <Grid2 item sx={{ alignItems: "center" }}>
                                <InputLabel className='overViewInputs'>Recruiter Id</InputLabel>
                                <Typography className="overViewDatas">{recruiterId}</Typography>
                            </Grid2> */}

              <Grid2 item sx={{ alignItems: "center" }}>
                <InputLabel className="overViewInputs">Name</InputLabel>
                <Typography
                  className="overViewDatas"
                  sx={{ color: "#6941C6", fontWeight: 600 }}
                >
                  {ViewRecruiterDetailsById?.response?.data[0]?.name} - (
                  {ViewRecruiterDetailsById?.response?.data[0]
                    ?.isExternalRecruiter === "N"
                    ? "Internal"
                    : "External"}
                  )
                </Typography>
              </Grid2>

              <Grid2 item sx={{ alignItems: "center" }}>
                <InputLabel className="overViewInputs">Email</InputLabel>
                <Typography className="overViewDatas" sx={{ color: "#6941C6" }}>
                  {ViewRecruiterDetailsById?.response?.data[0]?.email || "-"}
                </Typography>
              </Grid2>

              <Grid2 item sx={{ alignItems: "center" }}>
                <InputLabel className="overViewInputs">
                  Date of Birth
                </InputLabel>
                <Typography className="overViewDatas">
                  {dayjs(
                    ViewRecruiterDetailsById?.response?.data[0]?.dob
                  ).format("DD-MM-YYYY") || "-"}
                </Typography>
              </Grid2>

              <Grid2 item sx={{ alignItems: "center" }}>
                <InputLabel className="overViewInputs">
                  Alternate Number
                </InputLabel>
                <Typography className="overViewDatas">
                  {ViewRecruiterDetailsById?.response?.data[0]
                    ?.alternateContactNumber || "-"}
                </Typography>
              </Grid2>

              <Grid2 item sx={{ alignItems: "center" }}>
                <InputLabel className="overViewInputs">
                  Work Category
                </InputLabel>
                <Typography className="overViewDatas">
                  {workCategories?.length === 0 ? ("-") : (
                    workCategories?.map((work, idx) =>
                      <Chip
                        key={idx}
                        label={Array.isArray(work) ? work.join(", ") : String(work)}
                        size="small"
                        sx={{
                          fontSize: "11px",
                          fontWeight: 500,
                          backgroundColor: "#EEF2FF",
                          color: work === "IT" ? "#6941C6" : "red",
                          height: 22,
                        }}
                      />
                    ))
                  }
                </Typography>



              </Grid2>
              {/* <Grid2
                item
                sx={{
                  alignItems: "center",
                }}
              >
                <InputLabel className="inputlabels" sx={{ width: "55%" }}>
                  Work Category
                </InputLabel>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    border: "1px solid #dddee4",
                    borderRadius: "10px",
                    backgroundColor: "#fafafa",
                  }}
                >
                  <Grid2 align="right" sx={{ padding: "5px" }}>
                    <Button
                      sx={{
                        color: "white", // text color
                        backgroundColor: "#895fdb", // background color
                        "&:hover": {
                          backgroundColor: "darkblue", // hover effect
                        },
                      }}
                      onClick={() => setEditCheck(true)}
                    >
                      Edit
                    </Button>
                  </Grid2>
                  <Controller
                    control={control}
                    name="category"
                    render={({ field }) => (
                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "wrap", // allow wrapping
                          gap: 2,
                        }}
                      >
                        {getWorkCategoryDropDown?.response?.map((option) => (
                          <Box
                            key={option.workCategoryId}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                              width: "100%",
                            }}
                          >
                            <Checkbox
                              disabled={checkLoading || !editCheck}
                              checked={selectedKeywordIds.includes(
                                option.workCategoryId
                              )}
                              onChange={() =>
                                handleCheckboxChange(option.workCategoryId)
                              }
                            />
                            {option.workCategoryName}
                          </Box>
                        ))}
                      </Box>
                    )}
                  />
                  {errors?.category?.message && (
                    <span style={{ color: "red", fontSize: "0.8rem" }}>
                      {errors?.category?.message}
                    </span>
                  )}
                </Box>
              </Grid2> */}

              {/* {external === 'Y' && (
                                <Grid2 item sx={{ alignItems: 'center' }}>
                                    <InputLabel className='overViewInputs'>Reward Type</InputLabel>
                                    <Typography className="overViewDatas">{rewardType === "FC" ? "Fixed Amount" : rewardType === "FP" ? "Fixed Percentage" : rewardType}</Typography>
                                    <Typography className="overViewDatas">
                                        {rewardType === "FC" ? (
                                            <>
                                                <CurrencyRupeeIcon sx={{ fontSize: '13px', color: '#a6aba5' }} />
                                                {rewardAmount}
                                            </>
                                        ) : rewardType === "FP" ? (
                                            `${rewardPercentage}%`
                                        ) : (
                                            0
                                        )}
                                    </Typography>

                                </Grid2>
                            )} */}
            </Grid2>

            <Grid2
              item
              container
              rowGap={2}
              sx={{
                display: "flex",
                flexDirection: "column",
                width: !isSmallScreen ? "40%" : "100%",
                marginTop: isSmallScreen && "15px",
              }}
            >
              <Grid2 item sx={{ alignItems: "center" }}>
                <InputLabel className="overViewInputs">Company Name</InputLabel>
                <Typography className="overViewDatas">
                  {ViewRecruiterDetailsById?.response?.data[0]?.companyName ||
                    "-"}
                </Typography>
              </Grid2>

              <Grid2 item sx={{ alignItems: "center" }}>
                <InputLabel className="overViewInputs">
                  Contact Number
                </InputLabel>
                <Typography className="overViewDatas">
                  {ViewRecruiterDetailsById?.response?.data[0]?.contactNumber ||
                    "-"}
                </Typography>
              </Grid2>

              <Grid2 item sx={{ alignItems: "center" }}>
                <InputLabel className="overViewInputs">Gender</InputLabel>
                <Typography className="overViewDatas">
                  {ViewRecruiterDetailsById?.response?.data[0]?.gender || "-"}
                </Typography>
              </Grid2>

              <Grid2 item sx={{ alignItems: "center" }}>
                <InputLabel className="overViewInputs">Address</InputLabel>
                <Typography className="overViewDatas">
                  {ViewRecruiterDetailsById?.response?.data[0]?.street || "-"}
                </Typography>
              </Grid2>

              <Grid2 item sx={{ alignItems: "center" }}>
                <InputLabel className="overViewInputs">
                  Position Level
                </InputLabel>
                {
                  PositionLevel?.length === 0 ? ("-") : (
                    PositionLevel?.map((level, index) => (
                      <Box key={index} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Box
                          sx={{
                            width: 10,
                            height: 10,
                            borderRadius: "50%",
                          }}
                          className={`status-dot ${level?.toLowerCase()}`}
                        />
                        <Typography className="overViewDatas">
                          {Array.isArray(level) ? level.join(", ") : String(level)}
                        </Typography>
                      </Box>
                    )))
                }


              </Grid2>

              {/* <Grid2 item sx={{ alignItems: "center" }}>
                <InputLabel className="inputlabels" sx={{ width: "55%" }}>
                  Job Position Level
                </InputLabel>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    border: "1px solid #dddee4",
                    borderRadius: "10px",
                    backgroundColor: "#fafafa",
                  }}
                >
                  <Grid2 align="right" sx={{ padding: "5px" }}>
                    <Button
                      sx={{
                        color: "white", // text color
                        backgroundColor: "#895fdb", // background color
                        "&:hover": {
                          backgroundColor: "darkblue", // hover effect
                        },
                      }}
                      onClick={() => setEditLevelCheck(true)}
                    >
                      Edit
                    </Button>
                  </Grid2>
                  <Controller
                    control={control}
                    name="level"
                    render={({ field }) => (
                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "wrap", // allows wrapping
                          gap: 2,
                        }}
                      >
                        {getPositionLevelDropDown?.response?.map((option) => (
                          <Box
                            key={option.jobPositionLevelId}
                            sx={{
                              width: "40%", // two items per row
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <Checkbox
                              disabled={checkLoading || !editLevelCheck}
                              checked={selectedLevelIds.includes(
                                option.jobPositionLevelId
                              )}
                              onChange={() =>
                                handleLevelChange(option.jobPositionLevelId)
                              }
                            />
                            {option.jobPositionLevelName}
                          </Box>
                        ))}
                      </Box>
                    )}
                  />
                  {errors?.level?.message && (
                    <span style={{ color: "red", fontSize: "0.8rem" }}>
                      {errors?.level?.message}
                    </span>
                  )}
                </Box>
              </Grid2> */}

              {/* <Grid2 item sx={{ alignItems: 'center' }}>
                                <InputLabel className='overViewInputs'>Status</InputLabel>
                                <Typography className={`statusrecruiterview-badge ${status?.toLowerCase()}`}>{status}</Typography>
                            </Grid2> */}
            </Grid2>
          </Grid2>
        </TabPanel>

        <TabPanel value={2}>
          {ViewRecruiterDetailsById?.response?.data?.[0]
            ?.secondLevelReasonDesc && (
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Typography sx={{ color: "red", fontWeight: 600 }}>
                  {
                    isDocsVerify === "N" ? (
                      ViewRecruiterDetailsById?.response?.data?.[0]
                        ?.secondLevelReasonDesc
                    ) : ("")
                  }
                </Typography>
              </Box>
            )}
          <Box sx={{ display: "flex", width: "100%", gap: "30px" }}>
            <Grid2
              container
              sx={{ display: "flex", width: "55%", flexDirection: "column" }}
            >
              {/* <div>
                                <Typography sx={{ color: '#181D27', fontSize: '18px', fontWeight: 'bold' }}>
                                    Rewards
                                </Typography>
                            </div>
                            <div style={{ display: !isSmallScreen ? 'flex' : "", justifyContent: 'space-between', marginTop: '10px' }}>
                                <Grid2 item container sx={{ display: 'flex', flexDirection: 'column' }} gap={2}>
                                    <Box>
                                        <InputLabel>Reward Type</InputLabel>
                                        <Typography variant="body3">{ViewRecruiterDetailsById?.response?.data[0]?.rewardType === "FC" ? "Fixed Amount"
                                            : ViewRecruiterDetailsById?.response?.data[0]?.rewardType === "FP" ? "Fixed Percentage"
                                                : ViewRecruiterDetailsById?.response?.data[0]?.rewardType || '---'}</Typography>
                                    </Box>

                                    <Box>
                                        <InputLabel>Reward Percentage</InputLabel>
                                        <Typography variant="body3">
                                            {ViewRecruiterDetailsById?.response?.data[0]?.rewardType === "FP"
                                                ? `${ViewRecruiterDetailsById?.response?.data[0]?.rewardPct}%`
                                                : '----'}
                                        </Typography>

                                    </Box>

                                </Grid2>

                                <Grid2 item container sx={{ display: 'flex', flexDirection: 'column', width: '45%' }} gap={2}>

                                    <Box>
                                        <InputLabel>Reward Amount</InputLabel>
                                        {ViewRecruiterDetailsById?.response?.data[0]?.rewardType === "FC" ? (
                                            <>
                                                <CurrencyRupeeIcon sx={{ fontSize: '13px', color: '#a6aba5' }} />
                                                <Typography variant="body3">
                                                    {ViewRecruiterDetailsById?.response?.data[0]?.rewardAmount}
                                                </Typography>
                                            </>
                                        ) : (
                                            <Typography variant="body3">----</Typography>
                                        )}
                                    </Box>

                                </Grid2>
                            </div> */}

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  marginTop: "10px",
                }}
              >
                <Typography
                  sx={{
                    color: "#181D27",
                    fontSize: "18px",
                    fontWeight: "bold",
                  }}
                >
                  Bank Details
                </Typography>
              </Box>

              <div
                style={{
                  display: !isSmallScreen ? "flex" : "",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
              >
                <Grid2
                  item
                  container
                  sx={{ display: "flex", flexDirection: "column" }}
                  gap={2}
                >
                  <Box>
                    <InputLabel>Account Name</InputLabel>
                    <Typography variant="body3">
                      {ViewRecruiterDetailsById?.response?.data[0]
                        ?.recruiterAccountName || "-"}
                    </Typography>
                  </Box>

                  <Box>
                    <InputLabel>Bank Name</InputLabel>
                    <Typography variant="body3">
                      {ViewRecruiterDetailsById?.response?.data[0]?.bankName ||
                        "-"}
                    </Typography>
                  </Box>

                  <Box>
                    <InputLabel>IFSC Code</InputLabel>
                    <Typography variant="body3">
                      {ViewRecruiterDetailsById?.response?.data[0]?.ifscCode ||
                        "-"}
                    </Typography>
                  </Box>
                </Grid2>

                <Grid2
                  item
                  container
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "45%",
                  }}
                  gap={2}
                >
                  <Box>
                    <InputLabel>Account Number</InputLabel>
                    <Typography variant="body3">
                      {ViewRecruiterDetailsById?.response?.data[0]
                        ?.accountNumber || "-"}
                    </Typography>
                  </Box>

                  <Box>
                    <InputLabel>Branch Name</InputLabel>
                    <Typography variant="body3">
                      {ViewRecruiterDetailsById?.response?.data[0]?.branch ||
                        "-"}
                    </Typography>
                  </Box>
                </Grid2>
              </div>

              <div style={{ marginTop: 15 }}>
                <Typography
                  sx={{
                    color: "#181D27",
                    fontSize: "18px",
                    fontWeight: "bold",
                  }}
                >
                  Career Details
                </Typography>
              </div>

              <div
                style={{
                  display: !isSmallScreen ? "flex" : "",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
              >
                <Grid2
                  item
                  container
                  sx={{ display: "flex", flexDirection: "column" }}
                  gap={2}
                >
                  <Box>
                    <InputLabel>Current Designation</InputLabel>
                    <Typography variant="body3">
                      {ViewRecruiterDetailsById?.response?.data[0]
                        ?.currentDesignation || "-"}
                    </Typography>
                  </Box>
                  <Box>
                    <InputLabel>Specialization</InputLabel>
                    <Typography variant="body3">
                      {ViewRecruiterDetailsById?.response?.data[0]
                        ?.specification || "-"}
                    </Typography>
                  </Box>
                </Grid2>

                <Grid2
                  item
                  container
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "45%",
                  }}
                  gap={2}
                >
                  <Box>
                    <InputLabel>Years of Experience</InputLabel>
                    <Typography variant="body3">
                      {ViewRecruiterDetailsById?.response?.data[0]
                        ?.yearsOfExperience || "-"}
                    </Typography>
                  </Box>

                  <Box>
                    <InputLabel>Linkedin Profile</InputLabel>
                    <a
                      href={
                        ViewRecruiterDetailsById?.response?.data[0]?.linkedinProfile?.startsWith(
                          "http"
                        )
                          ? ViewRecruiterDetailsById?.response?.data[0]
                            ?.linkedinProfile
                          : `https://${ViewRecruiterDetailsById?.response?.data[0]?.linkedinProfile}`
                      }
                      rel="noopener noreferrer"
                      target="_blank"
                      style={{ color: "#6941C6", textDecoration: "none" }}
                    >
                      {ViewRecruiterDetailsById?.response?.data[0]
                        ?.linkedinProfile === null
                        ? "---"
                        : "Profile Link"}
                    </a>
                  </Box>
                </Grid2>
              </div>

              <Box style={{ marginTop: 15 }}>
                <Typography
                  sx={{
                    color: "#181D27",
                    fontSize: "18px",
                    fontWeight: "bold",
                  }}
                >
                  Aadhar/PAN
                </Typography>
              </Box>

              <div
                style={{
                  display: !isSmallScreen ? "flex" : "",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
              >
                <Grid2
                  item
                  container
                  sx={{ display: "flex", flexDirection: "column" }}
                  gap={2}
                >
                  <Box>
                    <InputLabel>Aadhar Number</InputLabel>
                    <Typography variant="body3">
                      {ViewRecruiterDetailsById?.response?.data[0]
                        ?.aadhaarNumber || "-"}
                    </Typography>
                  </Box>
                </Grid2>

                <Grid2
                  item
                  container
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "45%",
                  }}
                  gap={2}
                >
                  <Box>
                    <InputLabel>PAN Number</InputLabel>
                    <Typography variant="body3">
                      {ViewRecruiterDetailsById?.response?.data[0]?.panNumber ||
                        "-"}
                    </Typography>
                  </Box>
                </Grid2>
              </div>
            </Grid2>

            <Grid2
              container
              sx={{
                display: "flex",
                justifyContent: "space-between",
                width: "35%",
              }}
            >
              <Grid2>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    marginTop: "10px",
                  }}
                >
                  <Typography
                    sx={{
                      color: "#181D27",
                      fontSize: "18px",
                      fontWeight: "bold",
                    }}
                  >
                    Documents
                  </Typography>
                </Box>

                <div style={{ marginTop: "8px" }}>
                  {files?.map((file, index) => (
                    <FileLink
                      key={index}
                      filePath={file.filePath}
                      displayName={file.displayName}
                    />
                  ))}
                </div>
              </Grid2>
            </Grid2>
          </Box>
        </TabPanel>
      </TabContext>

      <Grid2>
        <Dialog
          open={open}
          scroll="paper"
          maxWidth="sm"
          sx={{
            "& .MuiDialog-paper": {
              minWidth: "40vw",
              minHeight: "50vh",
            },
          }}
        >
          {/* Dialog Title */}
          <DialogTitle
            dividers
            sx={{
              fontWeight: "bold",
              alignItems: "center",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            Recruiter Suspension
            <CloseIcon
              sx={{ cursor: "pointer", color: "#A4A7AE" }}
              onClick={handleClose}
            />
          </DialogTitle>

          {/* Dialog Content */}
          <DialogContent>
            <InputLabel className="inputlabels">
              Reason for Rejection<span style={{ color: "red" }}>*</span>
            </InputLabel>
            <textarea
              value={reason}
              onChange={handleReason}
              placeholder="Enter Reason for Rejection"
              className="textareas"
              style={{
                width: "100%",
                height: "130px",
              }}
            />
            {reason === "" && (
              <span style={{ color: "red", fontSize: "0.85rem" }}>
                {isReason}
              </span>
            )}
          </DialogContent>

          {/* Dialog Actions (Footer) */}
          <DialogActions
            sx={{ justifyContent: "flex-end", paddingBottom: "16px" }}
          >
            <MUIButton
              title="Suspend"
              onClick={tabValue == 1 ? handleSuspend : handleSecondLvlSuspend}
              sx={{
                backgroundColor: "#FFF4ED",
                border: "1px solid #FFD6AE",
                color: "#D92D20",
              }}
            />
          </DialogActions>
        </Dialog>
      </Grid2>
    </Box>
  );
};
export default RecruiterDetails;
